module.exports = __webpack_public_path__ + "static/media/shinyLight.51f44ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/Telestrations/Assets/shinyLight.png
// module id = 7080
// module chunks = 0